import React, {useEffect, useState} from 'react';
import {IonContent, IonHeader, IonItem, IonModal, IonToolbar} from '@ionic/react';
import {arrowDown, arrowUp} from 'ionicons/icons';
import 'react-circular-progressbar/dist/styles.css';
import trailer from "../imgs/trailer.png";
import chevronRight from "../imgs/chevron-right.png";
import upArrow from "../imgs/up-arrow.png";
import gasoline from "../imgs/gasoline.png";
import documentIcon from "../imgs/document.png"
import greenCircle from "../imgs/green-circle.png";
import emptyCircle from "../imgs/empty-circle.png";
import {Link} from "react-router-dom";
import CountUp from 'react-countup';
import {ApiService} from "../api/ApiService";
import {DriverProfile} from "../api/model/DriverProfile";
import {UserState, userStore} from "../api/AuthService";
import {UserUtils} from "../utils/UserUtils";
import {LoadInfo as StoredLoadInfo} from "../api/model/LoadInfo";
import { toastStore } from '../components/AppToast';
import AnimateHeight from 'react-animate-height';
import HelpDirect from './HelpDirect';
import express from "../imgs/express.png"
import news from "../imgs/newspaper.png"

//////// -----------------> MOVE TO PROGRESS CHECKER <------------------\\\\\\\\\\\\\\
let interval: any
let interval2: any
let interval3: any
let interval4: any
let i = 0;
let h = 0;
let j = 0
let k = 0;

const ProfileInfo: React.FC = () => {

    const {driver, profilePictureUrl, username}: { driver: DriverProfile, profilePictureUrl: string } = userStore((state: UserState) => ({
        driver: state.driver,
        username: state.username,
        profilePictureUrl: state.profilePictureUrl
    }));

    const {storedLoadInfo}: { storedLoadInfo: StoredLoadInfo } = userStore((state: UserState) => ({storedLoadInfo: state.loadInfo}));

    const today = new Date();

  const [showNum, SetShowNum] = useState(0);
  const [showMilesNum, setShowMilesNum] = useState(0);
  const [showMotiveNum, setShowMotiveNum] = useState(0);

  const {division} = userStore((state: UserState) => ({division: state.driver?.division}));
  const [clearedDivision, setClearedDivision] = useState<boolean>(false);
  const [currentRate, setCurrentRate] = useState(0);
  const [showLatest, setShowLatest] = useState(false);
  const [showFuel, setShowFuel] = useState(false);
  const [lowDEF, setLowDEF] = useState<string>('no');
  const [DEFLevel, setDEFLevel] = useState<string>("");
  const [fuelLevel, setFuelLevel] = useState<string>("");
  const [height1, setHeight1] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [progressValue, setProgressValue] = useState<number>(0);
  const [countDownMonths, setCountDownMonths] = useState<number>(0);
  const [countDownDays, setCountDownDays] = useState<number>(0);
  const [totalGoalsNum, setTotalGoalsNum] = useState<number>(0);
  const [gameData, setGameData] = useState({
    COST_CENTER: "-",
    HIRE_DATE: "-",
    HIRE_TENURE_DAYS: 0,
    MILES_LIFETIME: 0,
    MILES_MTD: 0,
    MILES_MTD_RANK: 0,
    MILES_WTD: 0,
    MILES_WTD_RANK: 0,
    MPG_MTD_COSTCENTER_GROUP: "-",
    MPG_MTD_MILES: 0,
    MPG_MTD_MPG: 0,
    MPG_MTD_RANK: 0,
    MPG_MTD_TRUCK_GROUP: "-",
    MPG_WTD_COSTCENTER_GROUP: "-",
    MPG_WTD_MILES: 0,
    MPG_WTD_MPG: 0,
    MPG_WTD_RANK: 0,
    MPG_WTD_TRUCK_GROUP: "-",
    MTD_TEAM: 0,
    PRETRIPS_MTD_RANK: 0,
    PRETRIPS_WTD_RANK: 0,
    WTD_TEAM: 0,
    exectime: 0  
  }
)

  useEffect(() => {
    checkDivision();
    getGreetingTime();
    console.log("type is here", localStorage.getItem("type") === "trainee")
    if (localStorage.getItem("type") === "trainee") {
      getTraineePayMatrix()
    }
    ApiService.getGamificationDriver2("profileInfo").then(it => setGameData(it as any))
    .catch(error => {
      console.error(error);
    });
   }, []);

   const checkDivision = () => {
    if (division === "VNASH" || division === "NER" || division === "VCT" || division === "VVA" || division === "100" || division === "FNASH" || division === "FNR" || division === "500") {
      setClearedDivision(true);
    } else {
      setClearedDivision(false);
    }
  }

  function toProperCase (str: string) {
    if (str !== undefined) {
      return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    } else {
      return "";
    }
  }

  const sendFuelRequest = async () => {
    if (fuelLevel !== "" && DEFLevel !== "") {
      const emailAddress = await getEmailAddress();
      const emailBody = `Driver ${localStorage.getItem('username')} has request a fuel soltuion on unit: ${userStore.getState().driver?.unit} <br/> Fuel Level: ${fuelLevel} <br/> Low on DEF: ${lowDEF} <br/>DEF Level: ${DEFLevel}`;
      ApiService.sendEmail("Fuel solution", {to: [emailAddress], subject: `Fuel Solution for Unit: ${userStore.getState().driver?.unit}`, body: emailBody}).then(() => {setShowFuel(false); setLowDEF("no"); setDEFLevel(""); setFuelLevel("")});
      ApiService.sendEventCommand("Fuel Request", "eventCheck", "User requested a fuel solution");
    } else {
      toastStore.getState().setToast('Please fill out all the fields');
    }
  }

  function getTraineePayMatrix() {
    ApiService.getPayMatrix("profileInfo", {})
    .then(it => {console.log("pay matrix", it); processPayInfo(it)})
  }

  function processPayInfo(payInfo: any) {
    if (payInfo === null) {
      return;
    } else {
      console.log("setting pay here", Math.round(payInfo * 100) / 100 );
       setCurrentRate(Math.round(payInfo * 100) / 100)
    }
  }

  async function getEmailAddress() {
    const day = today.getDay();
    const hours = today.getHours()
    if (day !== 0 && day !== 6 && hours >= 7 && hours <= 16) {
      console.log("wsxi");
      return "wsxi-fuel@westernexp.com"
    } else {
      console.log("hotelfuel");
      return "HOTELSBUSTICKETSFUEL@westernexp.com"
    }
  }

  const getGreetingTime = () => {
    let date = new Date();
    let hours = date.getHours();
    let timeOfDay = '';
    if (hours < 12) {
      timeOfDay = 'Morning'
    } else if (hours >= 12 && hours <= 17) {
      timeOfDay = 'Afternoon'
    } else if (hours >= 17 && hours <= 24) {
      timeOfDay = 'Evening'
    }
    setGreeting(timeOfDay)
  }

  return (
    <IonItem lines="none" color="light">
       
       <IonModal isOpen={showLatest}>
          <IonHeader>
                <IonToolbar color="primary">
                  <p style={{fontFamily: "Montserrat, sans-seriff", padding: "0 8px"}} onClick={() => setShowLatest(false)}>Back</p>
                </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonItem color='light' lines="none">
              <div className='item-container'>
                <p>Latest Update</p>
                <h1><strong>Leader Boards!</strong></h1>
                <p className='subtitle'>Check out the leader boards to see the MPG standings. Do you have the best fuel efficiency in your division?!</p>
                  <Link className='western-button-link' to="/rewards">
                    <div className="space-between">
                      <p>Go to Division Standings</p>
                      <img src={chevronRight} style={{ height: "1.8vh"}}alt="arrow"/>
                    </div>
                  </Link>
              </div>
            </IonItem>
        </IonContent>
      </IonModal>

      <IonModal isOpen={showFuel}>
          <IonHeader>
                <IonToolbar color="primary">
                  <p style={{fontFamily: "Montserrat, sans-seriff", padding: "0 8px"}} onClick={() => setShowFuel(false)}>Back</p>
                </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonItem color='light' lines="none">
              <div className='item-container'>
                <h1><strong>Request Fuel Solution</strong></h1>
                <p className='subtitle'>Before requesting a fuel solution, please answer the following questions:</p>
                <IonItem color="transparent">
                  <p style={{ width: "60%", padding: '5px', alignItems: "center"}}>Current Fuel Level</p>
                  <div className="input-container">
                      <input id="trainee" className="input" type="text" placeholder=" " value={fuelLevel} onChange={e => setFuelLevel(e.target.value!)}/>
                      <p className="placeholder">Fuel Level</p>
                  </div>
                </IonItem> 
                <IonItem color="transparent">
                    <p style={{width: "60%", padding: '5px', alignItems: "center"}}>Are you low on DEF?</p>
                    <div className="input-container" style={{width: "25%", marginLeft: '15px'}}>
                        <select id="accident" className="input"  placeholder=" " value={lowDEF} onChange={e => {setLowDEF(e.target.value!);}} style={{ height: "20px", textAlign: "center"}}>
                            <option value={"no"}>No</option>
                            <option value={"yes"}>Yes</option>
                        </select>
                        <p className="placeholder" ></p>
                    </div>
                </IonItem> 
                <IonItem color="transparent" lines="none">
                    <p style={{width: "60%", padding: '5px', alignItems: "center"}}>DEF Level</p>
                    <div className="input-container">
                        <input id="trainee" className="input" type="text" placeholder=" " value={DEFLevel} onChange={e => setDEFLevel(e.target.value!)}/>
                        <p className="placeholder">DEF Level</p>
                    </div>
                </IonItem> 
                  <div className="space-between" style={{background: "#fff", borderRadius: "10px", marginTop: "10px"}} onClick={e => {sendFuelRequest()}}>
                    <p style={{paddingLeft: "10px"}}>Request Solution</p>
                    <img src={chevronRight} style={{ height: "1.8vh", paddingRight: '8px'}}alt="arrow"/>
                  </div>
              </div>
          </IonItem> 
        </IonContent>
      </IonModal>
      
      <div className="item-container" id="homePageTop">
        <div>
          <div style={!UserUtils.isTrainee() ? { display: "grid", gridTemplateColumns: "40% 58%", gap: "2vw", alignItems: "center", margin: "8px"} : { display: "flex", alignItems: "center", margin: "8px"}}>
            <div className='box__bg' style={{alignContent: "center", textAlign: "center", margin: "auto"}}>
              <div>
                  <span style={{fontSize: "16px"}}><b>{username !== undefined ? '' : ''} {username}</b></span>
              </div>
              <div className="game-stat">
                  <p><b>Unit</b></p>
                  <strong>{driver?.unit || '-'}</strong>
              </div>
            </div>

            <div className='western-button-link' style={{gap: "2vw"}}>
              <div className="game-stat" style={{display: "grid", marginBottom: "10px", boxShadow: "0 4px 4px #00000034"}}>
                <div style={{margin: "auto", display: "grid", justifyContent: "center"}}>
                  <span style={{fontSize: "16px"}}>Good {greeting},</span>
                  <strong style={{fontSize: "20px", marginTop: "10px"}}><span>{toProperCase((driver.name).substring(0, driver.name.indexOf(' ')))}!</span></strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="WalkThroughFeature1">
          {storedLoadInfo !== undefined ? <Link to="/currentload" className='western-button-link'>
            <div className="green" style={{background: "#34AAFF", boxShadow: "0 4px 4px rgba(0,0,0,0.25)", marginTop: "15px", marginBottom: "15px"}}>
              <img src={trailer} style={{height: "18px"}} alt="trailer" className="link-icon" /><p>View Current Load</p>
            </div>
          </Link> : null}

          <Link className='western-button-link' to="/registrations">
            <div style={{background: "#fff", boxShadow: "0 4px 4px rgba(0,0,0,0.25)", marginTop: "15px", marginBottom: "15px"}}>
              <img alt="key" className="link-icon" src={documentIcon} /><p>View Registrations</p>
            </div>
          </Link>
          
          <div style={{ marginBottom: "14px", textAlign: "center"}} onClick={ e => {setHeight1(!height1); console.log("expanded");}} aria-expanded={ height1 !== false }>
            <div className='western-button-link'>
              <div className="green" id="current-load-button">
                <p style={{paddingLeft: "15px"}}>Need Help?</p>
                <img src={height1 == true ? arrowUp : arrowDown} style={{ height: "2vh", paddingRight: "15px"}} alt="arrow"/>
              </div>
            </div>
          </div>
        </div>
        <AnimateHeight style={ height1 === true ? {border: "1px #c3c3c3 solid", overflowY: 'scroll', borderRadius: "10px" } : { overflowY: 'scroll'}} duration={500} height={ height1 === true ? 'auto' : 0 } id="loadSection">
          <HelpDirect/>
        </AnimateHeight>
      </div>
    </IonItem>
  );
};

export default ProfileInfo;
